'use strict';

/* Views */
import GuestList from './list/guest-list.component';
import GuestEdit from './edit/guest-edit.component';

/* Services */
import GuestService from '../../services/guest/guest.service';

export default angular.module('conduuApp.guests', [GuestList, GuestEdit, GuestService])
  .name;



// WEBPACK FOOTER //
// ./client/app/guest/index.js